import { i18n } from './i18n';

/**
 * Locale-aware formatting for the active language and region (e.g. "ar-EG"
 * gets Arabic-Indic digits). Use these instead of `toLocaleString()` or
 * `Intl.*(undefined, …)`, which follow the browser rather than the chosen language.
 */
function activeTag(): string {
  return i18n.language;
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(activeTag(), options).format(value);
}

export function formatPercent(fraction: number): string {
  return new Intl.NumberFormat(activeTag(), { style: 'percent', maximumFractionDigits: 0 }).format(
    fraction,
  );
}

export function formatDateTime(
  value: Date | string | number,
  options: Intl.DateTimeFormatOptions,
): string {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat(activeTag(), options).format(date);
}

export function formatTime(value: Date | string | number): string {
  return formatDateTime(value, { timeStyle: 'short' });
}

export function formatList(items: readonly string[], type: Intl.ListFormatType = 'conjunction'): string {
  return new Intl.ListFormat(activeTag(), { style: 'long', type }).format(items);
}
